var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"square",style:(_vm.positionStyle)},[(_vm.hasInfo)?_c('div',{staticClass:"info"},[_c('p',[_vm._v(_vm._s(_vm.infoContent.email))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.infoContent.phone))])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c31dbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhoneIcon.vue
// module id = null
// module chunks = 